<div class="sub-menu">
  <div class="sub-menu-items">
    <div *ngFor="let menu_item of menu.items" [class]="((currentURL$ | async) === menu_item.url) ? 'active' : ''" class="sub-menu-item" (click)="onClick(menu_item.url)">
        <i [class]="menu_item.icon"></i>
        <p class="bodySmallContent">{{menu_item.title}}</p>
    </div>
  </div>
</div>
